export const stock = [
  { path: 'leads', title: 'Leads recibidos', icon: 'mdi-car-search' },
  { path: 'leadsActive', title: 'Leads activos', icon: 'mdi-star' },
  { path: 'discount', title: 'Descuento autorizado', icon: 'mdi-currency-usd' },
  { path: 'bono', title: 'Bono de renovación', icon: 'mdi-car-outline' },
  { path: 'price.comment', title: 'Comentario de definición de precio', icon: 'mdi-comment-text-outline' },
]
